import { supabase } from '../supabaseClient';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGoogle } from '@fortawesome/free-brands-svg-icons';

function Login() {
  const handleLogin = async (provider) => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider,
        options: {
            redirectTo: `${process.env.REACT_APP_URL}/dashboard`,
            scopes: provider === 'linkedin_oidc' ? 'openid profile email' : 'email profile',
        },
      });

      if (error) throw error;
    } catch (error) {
      console.error("Error:", error.message);
      alert('Login failed: ' + error.message);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center bg-gradient-to-br from-white via-sky-200 to-white animate-gradient-x">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-72 h-72 bg-white rounded-full -top-28 -left-28 mix-blend-multiply filter blur-xl opacity-30 animate-blob"></div>
        <div className="absolute w-72 h-72 bg-sky-50 rounded-full -top-28 -right-28 mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute w-72 h-72 bg-white rounded-full -bottom-28 -left-28 mix-blend-multiply filter blur-xl opacity-30 animate-blob animation-delay-4000"></div>
      </div>

      {/* Login Card */}
      <div className="relative w-full max-w-md mx-4 backdrop-blur-lg bg-white/10 rounded-3xl shadow-2xl border border-white/20 overflow-hidden transition-all hover:bg-white/15">
        <div className="p-8 md:p-10">
          {/* Animated Logo */}
          <div className="flex justify-center my-4">
            <span className="flex items-center gap-1">
              <img 
                src="/logo_portoize.png" 
                alt="Portoize Logo"
                className="w-64 object-contain animate-float"
              />
              <div className="bg-blue-500 text-white px-2 py-1 rounded-full leading-none font-medium">
                BETA
              </div>
            </span>
          </div>

          {/* Content */}
          <div className="space-y-6">
            <h2 className="text-4xl font-bold text-center bg-clip-text text-transparent bg-gradient-to-r from-sky-700 to-sky-500">
              Welcome Back
            </h2>

            {/* Social Login Buttons */}
            <div className="space-y-4">
              <button
                onClick={() => handleLogin('linkedin_oidc')}
                className="w-full flex items-center justify-center gap-3 bg-[#0A66C2]/90 hover:bg-[#0A66C2] text-white py-4 px-6 rounded-xl transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl"
              >
                <FontAwesomeIcon 
                  icon={faLinkedin} 
                  className="w-6 h-6 transition-transform hover:scale-110" 
                />
                <span className="text-lg font-semibold">Continue with LinkedIn</span>
              </button>

              <button
                onClick={() => handleLogin('google')}
                className="w-full flex items-center justify-center gap-3 bg-white/90 hover:bg-white text-gray-800 py-4 px-6 rounded-xl transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl"
              >
                <FontAwesomeIcon 
                  icon={faGoogle} 
                  className="w-6 h-6 transition-transform hover:scale-110" 
                />
                <span className="text-lg font-semibold">Continue with Google</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Add these styles for animations */}
      <style jsx global>{`
        @keyframes gradient-x {
          0% { background-position: 0% 50% }
          50% { background-position: 100% 50% }
          100% { background-position: 0% 50% }
        }
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1) }
          33% { transform: translate(30px, -50px) scale(1.1) }
          66% { transform: translate(-20px, 20px) scale(0.9) }
          100% { transform: translate(0px, 0px) scale(1) }
        }
        @keyframes float {
          0% { transform: translateY(0px) }
          50% { transform: translateY(-20px) }
          100% { transform: translateY(0px) }
        }
        .animate-gradient-x {
          background-size: 400% 400%;
          animation: gradient-x 15s ease infinite;
        }
        .animate-blob {
          animation: blob 20s infinite;
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

export default Login;